import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import './SuggestionsBar.css';

export default function SuggestionsBar({ suggestions, onPick, disabled = false }) {
    const scrollRef = useRef(null);
    const [canScrollLeft, setCanScrollLeft] = useState(false);
    const [canScrollRight, setCanScrollRight] = useState(false);

    const updateAffordance = () => {
        const el = scrollRef.current;
        if (!el) return;
        const epsilon = 2;
        setCanScrollLeft(el.scrollLeft > epsilon);
        setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth - epsilon);
    };

    useLayoutEffect(() => {
        updateAffordance();
    }, [suggestions]);

    useEffect(() => {
        const el = scrollRef.current;
        if (!el) return;
        el.addEventListener('scroll', updateAffordance, { passive: true });
        window.addEventListener('resize', updateAffordance);
        return () => {
            el.removeEventListener('scroll', updateAffordance);
            window.removeEventListener('resize', updateAffordance);
        };
    }, []);

    if (!suggestions || suggestions.length === 0) return null;

    return (
        <div className="suggestions-bar-wrap">
            <span className={`suggestions-affordance${canScrollLeft ? '' : ' hidden'}`} aria-hidden="true">
                <svg viewBox="0 0 24 24" width="14" height="14"><path d="M15 6l-6 6 6 6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
            </span>
            <div className="suggestions-bar" role="list" ref={scrollRef}>
                {suggestions.slice(0, 3).map((s, i) => (
                    <button
                        key={i}
                        type="button"
                        role="listitem"
                        className="suggestion-chip"
                        disabled={disabled}
                        onClick={() => onPick(s)}
                        aria-label={`Use suggestion: ${s}`}
                    >
                        {s}
                    </button>
                ))}
            </div>
            <span className={`suggestions-affordance${canScrollRight ? '' : ' hidden'}`} aria-hidden="true">
                <svg viewBox="0 0 24 24" width="14" height="14"><path d="M9 6l6 6-6 6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
            </span>
        </div>
    );
}
